import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/fanalists.webp';
import screenshot_target from '../../../images/letterfunnel/thierrydereus.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Thierry de Reus"
      firstname="Thierry"
      companyname="Fanalists"
      competition="Arenametrix en Sports Alliance"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/thierrydereus.js